<template>
  <div class="placeholder" :style="{ width: width, height: height }">
  </div>
</template>

<script>
export default {
  name: "Placeholder",
  props: {
    height: {
      type: String,
      default: "32px"
    },
    width: {
      type: String,
      default: "128px"
    }
  }
};
</script>
